import React, { useMemo, useState, useEffect, Fragment } from "react";
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { makeStyles } from "@material-ui/core/styles";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import { format } from 'date-fns';
import InfoIcon from '@material-ui/icons/Info';
import RedoIcon from '@material-ui/icons/Redo';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import WarningIcon from '@material-ui/icons/Warning';
import Tooltip from '@material-ui/core/Tooltip';
// import movies from '../SearchedResults/movies'
import HomeService from '../../services/home'
// import UtilsService from '../../helpers/utils';
import Constant from '../../helpers/constant';
import AccountInfo from '../../services/accountInfo';
import { url } from '../../reducers/url';
import ProgressBar from '../../shared/ProgressBar/Progress';
import SearchManagementService from "../../services/searchmanagement";
import CancelSearchModal from "../../shared/Modal/CancelSearchModal";


const useStyles = makeStyles((theme) => ({
	grow: {
		flexGrow: 1,
		width: '96%',
		margin: '30px auto',
		minHeight: '260px',
		// borderBottom: '1px solid #cec7c7'
	},
	savedForm: {
		backgroundColor: '#f5f2f2',
		height: '500px',
		paddingLeft: "70px",
		paddingTop: "34px"
	},
	anchorTag: {
		textDecoration: 'none',
		color: "#008EC5",
		fontWeight: '700'
	},
	p: {
		color: "#74a4d8",
		size: "20px"
	},
	textHeading: {
		fontWeight: "700 !important",
		color: "#5A6868",
		marginBottom: "5px"
	},
	columnPadding: {
		paddingLeft: "27px",
		paddingTop: "20px"
	},
	pTagMargin: {
		marginBottom: "0px",
		// fontWeight: "500"
	},
	applicationPanelRow: {
		marginBottom: "15px"
	}
}));

const customStyles = {
	rows: {
	  style: {
		minHeight: '50px', // Sets the minimum height for rows
		borderBottom: '1px solid #0606061f', // Add border bottom to each row
	  }
	},
	headCells: {
	  style: {
		paddingLeft: '8px', // Padding for head cells
		paddingRight: '8px',
		borderBottom: '1px solid #0606061f', // Add border bottom to head cells
		'&:not(:last-child)': {
		  borderRight: '1px solid #0606061f', // Add border right to all but the last head cell
		},
		'&:first-child': {
		  borderLeft: '0',
		  maxWidth: '160px',
		},
		'&:nth-child(2)': {
		  maxWidth: '110px',
		},
		'&:nth-child(5), &:nth-child(4)': {
		  maxWidth: '200px',
		},
		fontSize: '14px',
		fontWeight: '700',
		color: '#777777',
		justifyContent: 'start !important',
	  }
	},
	cells: {
	  style: {
		paddingLeft: '8px', // Padding for data cells
		paddingRight: '8px',
		borderBottom: '1px solid #0606061f', // Add border bottom to data cells
		'&:not(:last-child)': {
		  borderRight: '1px solid #0606061f', // Add border right to all but the last data cell
		},
		'&:first-child': {
		  borderLeft: '0',
		},
		display: 'grid',
		justifyContent: 'start !important',
	  }
	},
	// noData: {
    //     style: {
    //         backgroundColor: '#292929', // Dark mode background for no data message
    //         color: 'white', // Text color for "No items were found"
    //         height: '100%',
    //         display: 'flex',
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //     },
    // },
  };
  const customStyle = {
	rows: {
	  style: {
		minHeight: '50px', // Sets the minimum height for rows
		borderBottom: '1px solid #777', // Add border bottom to each row
		color: '#ffffff',
	  }
	},
	headCells: {
	  style: {
		paddingLeft: '8px', // Padding for head cells
		paddingRight: '8px',
		borderBottom: '1px solid #777', // Add border bottom to head cells
		'div:hover': { // Specific hover style for div within head cell
			color: '#ffffff', // Hover text color
		},
		'&:not(:last-child)': {
		  borderRight: '1px solid #777', // Add border right to all but the last head cell
		},
		'&:first-child': {
		  borderLeft: '0',
		  maxWidth: '160px',
		},
		'&:nth-child(2)': {
		  maxWidth: '110px',
		},
		'&:nth-child(5), &:nth-child(4)': {
		  maxWidth: '200px',
		},
		fontSize: '14px',
		fontWeight: '700',
		color: '#ffffff',
		justifyContent: 'start !important',
		backgroundColor: '#292929',
	  }
	},
	cells: {
	  style: {
		paddingLeft: '8px', // Padding for data cells
		paddingRight: '8px',
		borderBottom: '1px solid #777', // Add border bottom to data cells
		'&:not(:last-child)': {
		  borderRight: '1px solid #777', // Add border right to all but the last data cell
		},
		'&:first-child': {
		  borderLeft: '0',
		},
		display: 'grid',
		justifyContent: 'start !important',
		backgroundColor: '#292929',
		color: 'inherit',
	  }
	},
	noData: {
        style: {
            backgroundColor: '#292929', // Dark mode background for no data message
            color: 'white', // Text color for "No items were found"
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
  };

const columns = [
	{
		name: "Type",
		selector: "type",
		sortable: false,
		center: true,
		style: {
			maxWidth: '160px'
		}
	},
	{
		name: "Date",
		selector: "date",
		sortable: false,
		center: true,
		style: {
			maxWidth: '110px'
		}
	},
	{
		name: "Actions",
		selector: "info",
		sortable: false,
		cell: row => <div data-tag="allowRowEvents"><div style={{ textAlign: 'left' }}>{row.info}</div></div>
	},
	{
		name: "Description",
		selector: "description",
		sortable: false,
		center: true,
		// cell: row => <div style={{ textAlign: 'left' }}>{row.description}</div>,
	},
	{
		name: "No. of results",
		selector: "results",
		sortable: false,
		style: {
			justifyContent: 'unset !important',
			maxWidth: '200px'
		}
	},
	{
		name: " ",
		selector: "report",
		sortable: false,
		center: true,
		style: {
			justifyContent: 'center !important',
			maxWidth: '200px'
		}
	}
];
const isIndeterminate = indeterminate => indeterminate;
const selectableRowsComponentProps = { indeterminate: isIndeterminate };


function RecentResults() {
	// Cancel a running workflow
	const [wfModalShow, setWfModalShow] = React.useState(false);
	const [cancelWfId, setCancelWfId] = useState('');

	const [searchResultData, setSearchResultData] = useState([]);
	const history = useHistory();
	const classes = useStyles();
	//const dispatch = useDispatch();
	const { t } = useTranslation('common');
	const userInfo = useSelector((state) => state.setUserInfo);
	const toggle = useSelector(state => state.setToggle.toggle);
	useEffect(() => {
		(async () => {
			// const result = dispatch(getSearchResult());
			getDefaultSearchResult();
		})();
	}, [userInfo]);
	const getDefaultSearchResult = async () => {
		const result = await HomeService.getSearchResults(history);
		// Fetch casAccess from gquser.get_info API
		let hasCasAccess = true;
		try {
			const accountData = await AccountInfo.getAccountInfo(history);
			if (accountData && accountData.response_content) {
				hasCasAccess = Boolean(accountData.response_content.casAccess);
			}
		} catch (e) {
			console.error('Error fetching account info:', e);
		}
		let tempArr = [];
		if (result && result.response_content && result.response_content.length > 0) {
			// tempArr = await UtilsService.mostRecentResCalculation(result,'home');
			tempArr = await getSearchDataArr(result, 'home', hasCasAccess);
		}


		// Getting only 9 array from the response as per the ppt documentation
		tempArr = tempArr.slice(0, 9);
		setSearchResultData(tempArr);
	}
	const cancelWorkflow = () => {
		SearchManagementService.cancelWorkflow(cancelWfId);
		setWfModalShow(false);
	};
	async function cancelWorkflowLink(e, wfId) {
		setCancelWfId(wfId);
		setWfModalShow(true);
		e.preventDefault();
	};
	const getProgressStatus = async (isCompleted) => {
		if (isCompleted) {
			getDefaultSearchResult();
		}
	}
	async function getSearchDataArr(data, pagetype, hasCasAccess = true) {
		try {
			let tempArr = [];
			let resultData;
			if (pagetype == 'searchfolder') {
				resultData = data.response_content.results;
			} else {
				resultData = data.response_content;
			}
			resultData.forEach(datas => {
				let tempObj = datas;
				let id = datas.id;
				// CAS access revoked: check if this workflow actually uses CAS databases
				const allCasDbs = datas.casDatabases && Array.isArray(datas.casDatabases) ? datas.casDatabases : [];
				const casDbsInSearch = (datas.databases || []).filter(db => allCasDbs.includes(db));
				const isCasNoAccess = !hasCasAccess && casDbsInSearch.length > 0;
				const nonCasDbs = isCasNoAccess ? (datas.databases || []).filter(db => !casDbsInSearch.includes(db)) : [];
				const isCasOnly = isCasNoAccess && nonCasDbs.length === 0;
				const isCasWithOthers = isCasNoAccess && nonCasDbs.length > 0;

				tempObj['date'] = datas.date ? format(new Date(datas.date), 'dd-MMM-yyyy') : null;
				const regex = /Fulltext/i;
				if (datas.type !== null && datas.type !== '') {
					const found = datas.type.match(regex);
					if (found && found.length > 0) {
						type = 'Documents';
					}
				} else {
					datas.type = ' '
				}
				let type = 'Alignments';

				let mostRecentTypeUrl = url.mostRecentTypeUrl
				mostRecentTypeUrl = mostRecentTypeUrl.replace('**', id);
				let typeUrl = process.env.REACT_APP_BASE_URL + mostRecentTypeUrl;
				if (datas.type != '') {
					if (datas.type === "GqWfMerge" && (datas.status == 'UNKNOWN' || datas.status == 'STILL_RUNNING')) {
						tempObj['results'] = <Fragment><ProgressBar getStatus={getProgressStatus} datas={datas} /> <a href="#" onClick={(e) => cancelWorkflowLink(e, id)} target="_blank" rel="noreferrer">Cancel</a></Fragment>;
					} else if (datas.type == 'GqWfSeqSearch') {
						tempObj['results'] = '';
					} else if (datas.type !== 'GqFolder') {
						if (datas.status == 'STILL_RUNNING') {
							tempObj['results'] = <Fragment><ProgressBar getStatus={getProgressStatus} datas={datas} /> <a href="#" onClick={(e) => cancelWorkflowLink(e, id)} target="_blank" rel="noreferrer">Cancel</a></Fragment>;
						}
						else if (datas.status == 'FAILED') {
							tempObj['results'] = <a href="#" className={(datas.status == 'FAILED' ? 'failedIconColor' : '')} onClick={(e) => e.preventDefault()}>Search Failed</a>;
						}
						else if (datas.status == 'CANCELLED') {
							tempObj['results'] = <span>Search cancelled</span>;
						}
						else {
							const isCmNoAccess = (datas.type === "GqWfCmSearch" || (datas.type === "GqWfAlndbCopy" && datas.parent_type === "GqWfCmSearch")) && userInfo && userInfo.current_user && userInfo.current_user.cmAccess === false;
							if (datas.results > 0) {
								if (isCmNoAccess) {
									tempObj['results'] = <Tooltip title="Access to these results requires an active subscription to the Chemical Modification Module." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{datas.results}</span></Tooltip>
								} else if (isCasNoAccess) {
									tempObj['results'] = <Tooltip title="Access to these results requires an active CAS Biosequences subscription." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{datas.results}</span></Tooltip>
								} else {
									tempObj['results'] = <a href={typeUrl} target="_blank" rel="noreferrer">{datas.results}</a>
								}
							} else {
								tempObj['results'] = <span>{datas.results === 0 ? datas.results : ''}</span>
								// tempObj['results'] = <span></span>
							}

						}
					} else {
						tempObj['results'] = <a href="#" onClick={(e) => e.preventDefault()}>Empty</a>;
					}
				} else {
					tempObj['results'] = <a href="#" onClick={(e) => e.preventDefault()}>Empty</a>;
				}
				let mostRecentClassicUrl = url.mostRecentClassicUrl
				mostRecentClassicUrl = mostRecentClassicUrl.replace('**', id);
				let classicLink = process.env.REACT_APP_API_URL + mostRecentClassicUrl;
				if (datas.type == 'GqWfSeqSearch') { // Blast Search
					classicLink = process.env.REACT_APP_API_URL + url.mostRecentClassicBlastUrl.replace('**', id);
				}
				const isCmNoAccess = (datas.type === "GqWfCmSearch" || (datas.type === "GqWfAlndbCopy" && datas.parent_type === "GqWfCmSearch")) && userInfo && userInfo.current_user && userInfo.current_user.cmAccess === false;
				tempObj['cmNoAccess'] = isCmNoAccess;
				tempObj['isCasNoAccess'] = isCasNoAccess;
				if (datas.status == 'FAILED') {
					tempObj["report"] = '';
				} else if (isCmNoAccess) {
					tempObj["report"] = <Tooltip title="Access to these results requires an active subscription to the Chemical Modification Module." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Classic</span></Tooltip>;
				} else if (isCasNoAccess) {
					tempObj["report"] = <Tooltip title="Access to these results requires an active CAS Biosequences subscription." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Classic</span></Tooltip>;
				} else {
					if (datas.type == 'GqWfSeqSearch') {
						tempObj["report"] = <Fragment><a href={classicLink} target="_blank" rel="noreferrer">Classic</a></Fragment>
					} else if (datas.type != '' && (datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED')) {
						if (datas.results.props.children && datas.results.props.children > 0) {
							if (datas.type == "GqWfABIpSearch") {
								let mostRecentReportUrl = url.mostRecentReportUrl
								mostRecentReportUrl = mostRecentReportUrl.replace('**', id);
								let reportLink = process.env.REACT_APP_BASE_URL + mostRecentReportUrl;
								if (userInfo.enableReactDisc === true) {
									reportLink = process.env.REACT_APP_BASE_URL + 'fulltext/index.html#/antibody/' + id + '/Unfiltered_Entire_Report';
								}
								tempObj["report"] = <Fragment><a href={reportLink} target="_blank" rel="noreferrer">Report</a>
									<span className="mx-2">|</span>
									<a href={classicLink} target="_blank" rel="noreferrer">Classic</a>
								</Fragment>
							} else if (datas.type !== "GqFolder") {
								tempObj["report"] = <Fragment>
									{/* <a target="_blank" rel="noreferrer">Result Report</a>
									<span className="mx-2">|</span> */}
									<a href={classicLink} target="_blank" rel="noreferrer">Classic</a>
								</Fragment>
							} else {
								tempObj["report"] = '';
							}
						} else {
							tempObj["report"] = '';
						}
					} else {
						tempObj["report"] = '';
					}
				}
				// Store original type before conversion for action icons
				const originalType = datas.type;
				tempObj['type'] = Constant['searchType'][datas.type] ? Constant['searchType'][datas.type] : datas.type;
				if (pagetype === "searchmanagement" || pagetype === "searchfolder") {
					tempObj["info"] = <Fragment>
						<a href="#" onClick={(e) => e.preventDefault()}><InfoIcon className={"mr-2 appLink pe-none " + (datas.status == 'FAILED' ? 'failedIconColor' : '')} /></a>
						<a href="#" onClick={(e) => e.preventDefault()}><RedoIcon className="mr-2 appLink" /></a>
						<a href="#" onClick={(e) => e.preventDefault()}><AccessAlarmIcon className="appLink" /></a>
					</Fragment>
				}
				if (pagetype === "home") {
					// Create fixed positions for each icon type
					const showInfoIcon = (
						(originalType === "GqWfFullTextSearch") ||
						(originalType !== "GqFolder" && originalType !== "DlPhysicalSeqdb" && originalType !== "DlVirtualSeqdb" && originalType !== "GqWfFullTextSearch" && datas.status != 'UNKNOWN') ||
						((originalType === "DlPhysicalSeqdb" || originalType === "DlVirtualSeqdb") && (datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED' && datas.status != 'UNKNOWN')) ||
						(originalType === "GqFolder" && (datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED'))
					);

					const cmNoAccess = (originalType === "GqWfCmSearch" || (originalType === "GqWfAlndbCopy" && tempObj.cmNoAccess) || datas.type === "CM" || (datas.type === "Save Filtered Result" && tempObj.cmNoAccess)) && userInfo && userInfo.current_user && userInfo.current_user.cmAccess === false;
					const showRedoIcon = (
						((originalType === "GqWfIpSearch" || datas.type === "IP Sequence") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED')) ||
						((originalType === "GqWfVariation" || datas.type === "Variation") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED')) ||
						((originalType === "GqWfABIpSearch" || datas.type === "Antibody") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED')) ||
						((originalType === "GqWfFullTextSearch" || datas.type === "Document") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED')) ||
						((originalType === "GqWfCmSearch" || datas.type === "CM") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED'))
					);

					const showAlertIcon = datas.is_schedulable && datas.is_scheduled;

					const showWarningIcon = (datas.statistics && datas.statistics.stats && datas.statistics.stats.maxreachedid && datas.statistics.stats.maxreachedid.length > 0) ||
						(originalType === "GqWfCmSearch" && datas.qdb_seq_empty === "1" && datas.statistics && datas.statistics.stats && datas.statistics.stats.maxreached && parseInt(datas.statistics.stats.maxreached) > 0 && (!datas.statistics.stats.maxreachedid || datas.statistics.stats.maxreachedid.length === 0));

					tempObj["info"] = <Fragment>
						{/* Position 1: InfoIcon - Fixed position */}
						<span className="mr-2" style={{display: 'inline-block', width: '24px', textAlign: 'center'}}>
							{showInfoIcon && (
								<>
									{originalType === "GqWfFullTextSearch" && <Link to={"/searchresdoc/" + encodeURIComponent(datas.id)} className="infoIcon appLink"><Tooltip title="Audit trail for Fulltext search" placement="top"><InfoIcon className={"appLink " + (datas.status == 'FAILED' ? 'failedIconColor' : datas.status == 'CANCELLED' ? 'cancelledIconColor' : '')} /></Tooltip></Link>}
									{originalType !== "GqFolder" && originalType !== "DlPhysicalSeqdb" && originalType !== "DlVirtualSeqdb" && originalType !== "GqWfFullTextSearch" && datas.status != 'UNKNOWN' && <Link to={"/searchresseq/" + encodeURIComponent(datas.id)} className="infoIcon appLink"><Tooltip title="Audit trail for this search" placement="top"><InfoIcon className={"appLink " + (datas.status == 'FAILED' ? 'failedIconColor' : datas.status == 'CANCELLED' ? 'cancelledIconColor' : '')} /></Tooltip></Link>}
									{(originalType === "DlPhysicalSeqdb" || originalType === "DlVirtualSeqdb") && (datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED' && datas.status != 'UNKNOWN') && <Link to={"/searchresdb/" + encodeURIComponent(datas.id)} className="infoIcon appLink"><Tooltip title="Database Details" placement="top"><InfoIcon className={"appLink " + (datas.status == 'FAILED' ? 'failedIconColor' : '')} /></Tooltip></Link>}
									{originalType === "GqFolder" && (datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/report/folder/" + encodeURIComponent(datas.id)} className="infoIcon appLink"><Tooltip title="Folder Details" placement="top"><InfoIcon className={"appLink " + (datas.status == 'FAILED' ? 'failedIconColor' : '')} /></Tooltip></Link>}
								</>
							)}
						</span>

						{/* Position 2: RedoIcon - Fixed position */}
						<span className="mr-2" style={{display: 'inline-block', width: '24px', textAlign: 'center'}}>
							{showRedoIcon && !isCasNoAccess && (
								<>
									{(originalType === "GqWfIpSearch" || datas.type === "IP Sequence") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/ipseqsearch/" + encodeURIComponent(datas.id)} ><Tooltip title="Redo this IP search" placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfVariation" || datas.type === "Variation") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/ipseqvariation/" + encodeURIComponent(datas.id)}><Tooltip title="Redo this Variation search" placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfABIpSearch" || datas.type === "Antibody") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/searchresantibody/" + encodeURIComponent(datas.id)}><Tooltip title="Redo this Antibody search" placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfFullTextSearch" || datas.type === "Document") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/fulltextsearch/" + encodeURIComponent(datas.id)}><Tooltip title="Redo this Fulltext search" placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfCmSearch" || datas.type === "CM") && !cmNoAccess && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/cmsearch/" + encodeURIComponent(datas.id)}><Tooltip title="Redo this CM search" placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfCmSearch" || datas.type === "CM") && cmNoAccess && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Tooltip title="CM access required to redo this search" placement="top"><RedoIcon style={{color: '#999', cursor: 'not-allowed'}} /></Tooltip>}
								</>
							)}
							{showRedoIcon && isCasWithOthers && (
								<>
									{(originalType === "GqWfIpSearch" || datas.type === "IP Sequence") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/ipseqsearch/" + encodeURIComponent(datas.id)} ><Tooltip title={`Redo will rerun against ${nonCasDbs.join(', ')} only (CAS databases excluded)`} placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfVariation" || datas.type === "Variation") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/ipseqvariation/" + encodeURIComponent(datas.id)}><Tooltip title={`Redo will rerun against ${nonCasDbs.join(', ')} only (CAS databases excluded)`} placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfABIpSearch" || datas.type === "Antibody") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/searchresantibody/" + encodeURIComponent(datas.id)}><Tooltip title={`Redo will rerun against ${nonCasDbs.join(', ')} only (CAS databases excluded)`} placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfFullTextSearch" || datas.type === "Document") && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/fulltextsearch/" + encodeURIComponent(datas.id)}><Tooltip title={`Redo will rerun against ${nonCasDbs.join(', ')} only (CAS databases excluded)`} placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfCmSearch" || datas.type === "CM") && !cmNoAccess && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Link to={"/cmsearch/" + encodeURIComponent(datas.id)}><Tooltip title={`Redo will rerun against ${nonCasDbs.join(', ')} only (CAS databases excluded)`} placement="top"><RedoIcon className="appLink" /></Tooltip></Link>}
									{(originalType === "GqWfCmSearch" || datas.type === "CM") && cmNoAccess && (datas.status != 'ARCHIVED' && datas.status != 'STILL_RUNNING' && datas.status != 'CANCELLED') && <Tooltip title="CM access required to redo this search" placement="top"><RedoIcon style={{color: '#999', cursor: 'not-allowed'}} /></Tooltip>}
								</>
							)}
							{showRedoIcon && isCasOnly && (
								<Tooltip title="Redo is not available — this search was run against CAS databases only." placement="top"><RedoIcon style={{color: '#bbb', cursor: 'not-allowed'}} /></Tooltip>
							)}
						</span>

						{/* Position 3: AlertIcon - Fixed position */}
						<span className="mr-2" style={{display: 'inline-block', width: '24px', textAlign: 'center'}}>
							{showAlertIcon && !cmNoAccess && !isCasNoAccess && <Tooltip title="Alert set for this search" placement="top"><AccessAlarmIcon className="appLink" /></Tooltip>}
							{showAlertIcon && cmNoAccess && <Tooltip title="CM access required - alert deactivated" placement="top"><AccessAlarmIcon style={{color: '#999', cursor: 'not-allowed'}} /></Tooltip>}
							{showAlertIcon && isCasWithOthers && !cmNoAccess && <Tooltip title={`Alert redos will run against ${nonCasDbs.join(', ')} only (CAS databases excluded)`} placement="top"><AccessAlarmIcon className="appLink" /></Tooltip>}
							{showAlertIcon && isCasOnly && !cmNoAccess && <Tooltip title="Alert deactivated — this search was run against CAS databases only." placement="top"><AccessAlarmIcon style={{color: '#bbb', cursor: 'not-allowed'}} /></Tooltip>}
						</span>

						{/* Position 4: WarningIcon - Fixed position */}
						<span style={{display: 'inline-block', width: '24px', textAlign: 'center'}}>
							{showWarningIcon && (
								<Tooltip 
									title={
										datas.statistics && datas.statistics.stats && datas.statistics.stats.maxreachedid && datas.statistics.stats.maxreachedid.length > 0
											? `WARNING: The following queries have reached the max number of hits: ${datas.statistics.stats.maxreachedid.join(' ')}`
											: `WARNING: This search reached the max number of hits: ${datas.statistics && datas.statistics.stats && datas.statistics.stats.maxreached ? datas.statistics.stats.maxreached : '10000'}`
									} 
									placement="top"
								>
									<WarningIcon className="appLink" style={{color: '#e9b34f'}} />
								</Tooltip>
							)}
						</span>
					</Fragment>
				}
				tempArr.push(tempObj);
			})
			return tempArr;
		} catch (error) {
			console.error(error);
		}

	}

	return (

		<div className={classes.grow}>
			{/* <ProgressBar /> */}
			<Row >
				<Col>
					<span className={"subHeading"}>Most Recent Results</span><span className="pipeText appTextColor">|</span><span className={classes.pTagMargin + " bodyText"}>
						{/* <a className={classes.anchorTag} href='#' onClick={e => e.preventDefault()}>All Search Results</a> */}
						<Link className="appLink" to='/searchResult'>All Search Results</Link>
					</span>
				</Col>
			</Row>
			<Row className="mt-2">
				<Col>
					{/* <Table className="w-100" columns={columns} data={data} /> */}
					<DataTable
						columns={columns}
						data={searchResultData}
						defaultSortField="date"
						defaultSortAsc={false}
						sortable={false}
						sortServer={true}
						noDataComponent={t("noSearchSubmit")}
						sortIcon={<SortIcon />}
						customStyles={toggle ? customStyles : customStyle}
						conditionalRowStyles={[{
							when: row => row.cmNoAccess,
							style: toggle ? { color: '#bbb', fontStyle: 'italic' } : { color: '#8c8c90', fontStyle: 'italic' },
						}, {
							when: row => row.isCasNoAccess,
							style: toggle ? { color: '#bbb', fontStyle: 'italic' } : { color: '#8c8c90', fontStyle: 'italic' },
						}]}
						noHeader={true}
					/>
				</Col>
			</Row>

			<CancelSearchModal show={wfModalShow} onHide={() => setWfModalShow(false)} tryAgain={() => cancelWorkflow()}/>

			{/* <ProgressBar animated now={75} /> */}

		</div>

	);
}

export default RecentResults;
